import {
    askQuestion,
    createElementFromHTML,
    fetchServer, formatWord,
    handleFetchError,
    showNotice,
    YummyServerError
} from "./helpers/functions.js";
import {countWords} from "./helpers/bbutils.js";
import {ServerApi} from "./api.js";
import JSX from "./helpers/react.js";
import {slimCustom} from "./helpers/slim-select.jquery.js";
import {IReviewJson} from "../../../nodeserver/structs/database";

function AddReviewBtn() {
    return (
        <a href="/reviews/create" className="add-new-review" data-balloon="Добавить рецензию" data-balloon-pos="left">
            <i className="fa-plus fa"/>
        </a>
    )
}

function MoreReviesBtn() {
    return (
        <div className="more-reviews main-button bordered" onClick={() => Reviews.Instance.getReviews()}>
            Ещё рецензии
        </div>
    )
}

interface IReview {
    anime_id: number;
    avatar: string;
    commentable: string;
    created_at: string;
    id: number;
    name: string;
    notice_me: boolean;
    published: boolean;
    status: number;
    text: string;
    time: number;
    updated_at: string;
    rating: string;
    user_id: number;
    views: number;
    is_reviewer: boolean;
}

function updateRatingBlock(this: HTMLElement, average: number) {
    if (average == 5 || average == 0) {
        $(this).removeClass('good bad')
    } else if (average < 5 && !$(this).hasClass("bad")) {
        $(this).removeClass("good")
            .addClass("bad");
    } else if (average > 5 && !$(this).hasClass("good")) {
        $(this).removeClass("bad")
            .addClass("good");
    }
}

function updateGlobalRatingBlock() {
    $('.rating-block').each(function () {
        const average = ~~$(this).find('.average-rating').text();
        updateRatingBlock.call(this, average);
    });
}

function NothingReviewsFound(props: { data: { can_add: boolean } }) {
    return (
        <div className="status-bg alert-bg bordered">
            Еще нет проверенных рецензий
            {props.data.can_add && <AddReviewBtn/>}
        </div>
    )
}

class Reviews {

    private sort: 'new' | 'top' | 'old' = 'new';
    private skip: number = 0;
    private offset: number = 0;

    static Instance = new Reviews();

    public sortBy(button: JQuery, orderBy: 'new' | 'top' | 'old') {
        this.offset = this.skip = 0;
        this.sort = orderBy;
        $('.sort-block.reviews-sort .sub-menu-inner-container').removeClass('show')
            .find('.default-button').removeClass('active');
        $(button).addClass('active');
        $('.reviews-block').html('');
        this.getReviews().catch(console.error);
    }

    private async loadReviewsJson() {
        $('.more-reviews').remove();
        return ServerApi.reviews.getByAnime(page_id!, {
            offset: this.skip,
            sort: this.sort
        });
    }

    async getReviews() {
        try {
            const data = await this.loadReviewsJson(),
                oldScroll = $(window).scrollTop()!,
                sortBlock = $('.sort-block.reviews-sort').removeClass('hidden');
            if (data.reviews.length === 0 && this.offset === 0) {
                sortBlock.html(<NothingReviewsFound data={data}/>);
            }
            if (data.reviews.length >= 10) {
                document.querySelector('.more-reviews-container')!
                    .appendChild(<MoreReviesBtn/>)
            }

            this.offset++;
            this.skip = this.offset * 10;

            $.each(data.reviews, function () {
                const html = Reviews.buildHtmlFromReview(this as IReviewJson & {text_html: string})
                    .appendTo('.reviews-block');
                $(window).scrollTop(oldScroll);
            });
            updateGlobalRatingBlock();
        } catch (e) {
            handleFetchError(e);
        }
    }

    public static buildHtmlFromReview(review: IReviewJson&{text_html: string}): JQuery {
        let ratingHtml = '';

        if (review.rating) {
            function averageRating(rating: Array<{
                category: string,
                average: number
            }>) {
                if(!('reduce' in rating)) return 0;
                const ans = (
                    rating.reduce(
                        (a, b) => a + (+b.average), 0
                    ) / rating.length
                );
                return ans.toFixed(0);
            }

            const rating = review.rating,
                ratingAverage: string | number = (rating.average ?? 0) || averageRating(Object.entries(rating.category).map(e=>({category: e[0], average: e[1]})));


            ratingHtml = (
                <div className="rating-block bordered">
                    {
                        !!Object.keys(rating.category ?? {}).length &&
                        <ul className="rating-block-item rating-category">
                            {
                                ...Object.entries(rating.category!).map(([k, v]) =>
                                    <ReviewRating k={k} v={+v}/>
                                )
                            }
                        </ul>
                    }
                    {!isNaN(ratingAverage as number) && ratingAverage != 0 &&
                        <div className="rating-block-item rating-average rating-category-item">
                            <div className="rating-category-key">Итоговая оценка:</div>
                            <div className="rating-average-value rating-category-value">
                                <span className="average-rating">{ratingAverage}</span>
                                <span className="rating-average-full"> / 10</span>
                                <span className="under-average-rating">{ratingList[+ratingAverage]}</span>
                            </div>
                        </div>
                    }
                </div>
            );
        }

        const ans = $(
            <div className="comment non-auth one-review" data-id={review.review_id}>
                <a href={`/users/id${review.author.id}`} className="comment-img">
                    <img className="bordered" src={review.author.avatars.big} alt=""/>
                </a>
                <div className="comment non-auth" data-id={review.review_id}>
                    <div>
                        <div className="comment-head">
                            <div className="comment-top">
                                <a href={`/users/id${review.author.id}`}
                                   className={`comment-author${review.user_roles?.includes('reviewer') ? ' reviewer' : ''}`}>{review.nickname}</a>
                                <div style={{width: '100%', fontSize: '12px'}}>
                                    <local-time className="comment-date" data-time={review.update_date}
                                                style={{width: 'auto'}}/>
                                    , {review.views + ' ' + formatWord(review.views, 'просмотр', 'просмотра', 'просмотров')}
                                </div>
                            </div>
                            {!!user_id && user_id == review.author.id &&
                                <div className="comment-controls">
                                    <span className="drop-menu-click far fa-fw fa-ellipsis-h"></span>
                                    <div className="hidden-menu invisible">
                                        <div className="drop-list">
                                            <a href={`/reviews/edit/${review.review_id}`}
                                               className="drop-menu-item">Редактировать</a>
                                            <div className="drop-menu-item remove-review">Удалить</div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <ReviewText html={review.text_html} id={review.review_id}/>
                    </div>
                    {ratingHtml}
                </div>
            </div>
        );
        return ans;
    }

}

//@ts-ignore
window['reviews'] = Reviews.Instance;

$('html')
    .on('input', '.reviews-page .rating-category-item', function () {
        const val = +$(this).find('.rating-input[type="number"]').val()! as number;
        updateRatingBlock.call(this, val);
        $(this).find('.rating-category-text').text(ratingList[val]!);
    })
    .on('submit', '.review-form', async function (e) {
        e.preventDefault();
        if ($(this).hasClass('blocked')) return;
        $(this).addClass('blocked');
        try {
            await submitEditReviewForm($(this));
        } catch (e) {
            handleFetchError(e);
        } finally {
            $(this).removeClass('blocked');
        }

    })
    .on('click', '.add-new-rating', addNewRating)
    .on('click', '.remove-review', async function removeReview() {
        const $this = $(this),
            reviewId = $this.parents('.comment').data('id')! as number;
        if (!confirm('Вы уверены, что хотите удалить эту рецензию?')) return;
        try {
            const data = await fetchServer<{ message: string; status: number; error?: string; }>(
                `/reviews/${reviewId}?verify=1`, 'DELETE'
            );
            const comment: JQuery = $this.parents('.comment');
            comment.css({'opacity': 0, 'margin-top': comment.outerHeight()! * -1});
            setTimeout(function () {
                $this.parents('.comment').remove();
            }, 1000);
            showNotice("Рецензия успешно удалена", 'Удаление рецензии', 'success');
        } catch (e) {
            handleFetchError(e);
        }
    })
    .on('click', '.review-controls .fa-trash-alt', function (e) {
        e.preventDefault();
        if (confirm('Вы уверены, что хотите удалить эту рецензию?')) {
            location.href = $(this).attr('href')! as string;
        }
    })
    .on('click', '#reviews', function () {
        if (!$(this).data('clicked')) {
            $(this).data('clicked', true);
            Reviews.Instance.getReviews().catch(console.error);
        }
    })
    .on('click', '.close-rating', function () {
        $(this).parents('.rating-category-item').remove()
    })
    .on('click', '.sort-reviews-btn', function () {
        Reviews.Instance.sortBy(this, $(this).data('by')! as 'new' | 'top' | 'old');
    })
    .on('click', '.publish-review, .ban-review', async function () {
        if (page_type !== 'review') return showNotice('Вы не находитись на странице рецензии!', 'Ошибка', 'error')
        if ($(this).parent().hasClass('blocked')) return;
        $(this).parent().addClass('blocked');
        try {
            const publish = !$(this).hasClass('ban-review');
            let conf: 0 | 1 | -1 = 0, comment = undefined;
            if (publish && confirm('Одобрить рецензию?\nПожалуйста, убедитесь, что в тексте нет орфографических ошибок и он несет в себе смысл!'))
                conf = 1;
            if (!publish) {
                try {
                    comment = await askQuestion(
                        'Отклонить рецензию?',
                        <>
                            Отклоняйте рецензию, если там бред/некультурная лекска/не по теме.<br/>
                            Также отклоняйте рецензию, если там есть орфографические ошибки (с соответвующим
                            комметарием)
                        </>
                    );
                    conf = -1;
                } catch (e) {
                    //Rejected
                }
            }
            if (conf) {
                await ServerApi.reviews.update(page_id!, {
                    published: conf,
                    decline_comment: comment
                });
                showNotice(`Рецензия была ${conf == 1 ? 'Одобрена' : 'Отклонена'} Вашим голосом.`);
                setTimeout(() => window.location.reload(), 1000)
            }
        } catch (e) {
            handleFetchError(e);
        } finally {
            $(this).parent().removeClass('blocked');
        }
    })
    .on('input', '.review-text', function () {
        localStorage['lastReviewText'] = $(this).html();
    })
    .on('click', '#check-orthography', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const $element = $($this.data('for'));
            $element.find('.give').remove();
            for (const el of Array.from($element.find('.orthography-error'))){
                el.outerHTML = el.innerHTML;
            }

            interface OrthographyError {
                code: number;
                col: number;
                len: number;
                pos: number;
                row: number;
                s: string[];
                word: string
            }

            let htmlNow = ($element.html()! as string).replace('&nbsp;', ' ');
            const response = await fetchServer<OrthographyError[]>(
                'https://speller.yandex.net/services/spellservice.json/checkText', 'POST', {
                    body: new URLSearchParams({
                        text: htmlNow,
                        format: 'html',
                        lang: 'ru',
                        options: 8 | 4
                    } as any)
                });
            if (response.length) {
                let offset = 0;
                for (let error of response) {
                    const addNewText = `<span class="orthography-error" data-balloon="${error.s.join(', ')}" data-balloon-pos="${error.pos > 200 ? 'up' : 'down'}" data-fixes="${escapeHtml(JSON.stringify(error.s))}">${error.word} <i class="fa fa-check give"></i></span>`;
                    htmlNow = htmlNow.substring(0, error.pos + offset) + addNewText + htmlNow.substring(error.pos + error.len + offset);
                    offset += addNewText.length - error.len;
                }
                $element.html(htmlNow);
            } else {
                showNotice('Орфографических ошибок не найдено!\nТак держать!', 'Ошибок нет.', 'success')
            }
        } catch (e) {
            handleFetchError(e);
        } finally {
            $(this).removeClass('blocked');
        }

    })
    .on('click', '.orthography-error .give', function () {
        const $parent = $(this).parent();
        const $fixes = $parent.data('fixes') as string[];
        if ($fixes.length === 1) {
            $parent.replaceWith($fixes[0]);
        } else if ($fixes.length > 1) {
            $parent.replaceWith($fixes[0])
        } else {
            $parent.replaceWith($parent.text());
        }
    })

//Edit reviews
export function onLoad() {
    $('.reviews-page .rating-category-item').trigger('input');
    if ($('.reviews-page')[0] && $('.reviews-page .rating-category').children().length < 2)
        addNewRating();

    function slimSelectAjax(this: JQuery, aj: (search: string, callback: Function) => any) {
        let si: any;
        this.each(function () {
            const th = this;
            const d = slimCustom.apply(this as HTMLSelectElement);
            d.searchingText = 'Поиск...';
            d.ajax = function (search: any, callback: any) {
                clearTimeout(si);
                if (search.length < 3)
                    return callback('Введите не менее 3-х символов')
                si = setTimeout(function () {
                    aj(search, (a: any)=>{
                        console.log("Setting a", a);
                        // @ts-ignore
                        th.slim.setData(
                            //@ts-ignore
                            a.map(e=>({text: e.text, value: e.value+""}))
                        )
                    })
                }, 500);
            }
            //@ts-ignore
            new SlimSelect(d)
        })
        return this;
    }
    $('input[name=enter_search_query]').on('input', async function(this: HTMLInputElement){
        const string = this.value
        const response = await ServerApi.anime.search(string);
        const el = document.querySelector('select#anime_id')!;
        el.innerHTML = '';
        for(const e of response){
            el.appendChild(<option value={e.anime_id}>{e.title}</option>);
        }
    });

    // slimSelectAjax.call($('select#anime_id'), async function (search, callback) {
    //     try {
    //         const result = response.map(elem => ({value: elem.anime_id, text: elem.title}));
    //         console.log(result);
    //         callback(result);
    //     } catch (e) {
    //         handleFetchError(e);
    //         callback(false);
    //     }
    // });
    const av = $('#average-rating');
    if (av[0] && !$('.review-form')[0]) {
        let summ = 0, average;

        if ($('.rating-category-num-item').length > 0) {
            $('.rating-category-num-item').each(function (i, e) {
                var rate_class = '';
                var rate = parseInt($(e).text());
                if (rate < 5) {
                    rate_class = 'bad';
                } else if (rate > 5) {
                    rate_class = 'good';
                }
                $(e).parents('.rating-category-item').addClass(rate_class);
                summ += rate;
                $(e).parents('.rating-category-value').find('.rating-category-text').text(ratingList[parseInt($(e).text())]);
            });

        }
        if (!(+av.text()))
            average = (summ / $('.rating-category-num-item').length).toFixed(0);
        else average = +(av.text());


        updateGlobalRatingBlock();
        av.text(average);
        $('.under-average-rating').text(ratingList[average as number]);

    }

    if ($('.rate-review-item.active').length > 0) {
        $('.rate-review-item.active').each(function (i, e) {
            $(e).trigger('click');
        });
    } else {
        $('#middle-rating').trigger('change');
    }

    if ($('.n-replace').length > 0) {
        var text = $('.n-replace').html();
        text = text.replace(/\n/g, '<br>');
        $('.n-replace').html(text);
    }
    if ($('.review-text').text().trim().length < 30)
        $('.review-text').html(localStorage.lastReviewText ?? "");
}

export function addNewRating() {
    $(
        <li className="rating-category-item">
            <i className="fa fa-close close-rating"/>
            <div className="rating-category-key"><input name="rating_text" type="text" className="rating-input bordered"
                                                        min="0"
                                                        max="10" step="1" placeholder="Категория"/></div>
            <div className="rating-category-value">
                <div className="rating-category-num">
            <span className="rating-category-num-item">
                <input name="rating" className="rating-input bordered" type="number" value="0" min="0" max="10"
                       step="1"/>
            </span>
                    <span>/ 10</span>
                </div>
                <div className="rating-category-text">Не выбрано</div>
            </div>
        </li>
    ).insertBefore('.add-new-rating')
}

async function submitEditReviewForm(form: JQuery<HTMLElement>) {
    const ratingArr: ([string, number])[] = Array.from(form.find('.rating-block-item .rating-category-item'))
        .map(el => [
            $(el).find('input[name=rating_text]').val()! as string,
            +$(el).find('input[name=rating]').val()!,
        ] as [string, number])
        .filter(e => e[1] && e[0]), average = +form.find('#average-rating input').val()! as number;

    const text = form.find('.comment-textarea').html(),
        anime_id = +form.find('#anime_id').val()!,
        review_id = form.find('input[name=review_id]').val() ?? null,
        commentable = (+form.find('#commentable').prop('checked')!) ?? true;
    if (countWords(form.find('.comment-textarea')[0]!) < 250)
        throw new YummyServerError('Текст рецензии слишком маленький - минимум 250 слов.');
    else if (!anime_id) throw new YummyServerError('Аниме не задано!');
    let response;
    if (review_id) {
        response = await ServerApi.reviews.update(+review_id!, {
            text,
            anime_id,
            rating: {
                average: average,
                category: ratingArr.map(([name, value]) => ({category: name, average: value}))
            },
            commentable: !!commentable
        });
    } else {
        response = await ServerApi.reviews.create({
            text,
            anime_id,
            rating: {
                average: average,
                category: ratingArr.map(([name, value]) => ({category: name, average: value}))
            },
            commentable: !!commentable
        });
    }
    localStorage.removeItem('lastReviewText')
    window.location.href = `/reviews/${response.review_id}`;
}


// function smart_substr(str: string, len: number) {
//     let temp = str.substring(0, len);
//     if (temp.lastIndexOf('<') > temp.lastIndexOf('>')) {
//         temp = str.substring(0, 1 + str.indexOf('>', temp.lastIndexOf('<')));
//     }
//     return temp;
// }
/**
 * Returns html that is stripped to certain character length
 * @param {string} src html content to be stripped
 * @param {number} length max length
 * @param {bool|string=} suffix append dots (or provided string) at the end
 * @returns {string} stripped html
 */
function html_substr(src: string, length: number, suffix: boolean | string): string
{
    src = src.replace(/<img[^>]*>/g, "");
    if (length >= src.length) return src;
    let str = "", //final content
        i = 0, //position in source
        tag = '', //current tag contents (used during content reading)
        c = '', //current char (used during content reading)
        end = 0, //ending position of tag (used during content reading)
        len = src.length, //lenght of the source
        cnt = 0, //content size
        tagTree: string[] = [], //open tags

        /**
         * Strips parameters and <> from tag
         * @param {string} content full tag content (ex.: <span a="b">)
         * @returns {string} tag name (ex.: span)
         */
        tagStrip = function (content: string): string {
            var index = tag.indexOf(" "); //check for space (ex.: <span a="b">)
            if (index == -1) { //no space (ex.: <span>)
                return content.slice(1, -1);
            }
            return content.slice(1, index);
        };

    //Go through the content until we read enough of it
    while (cnt < length && i < len) {
        c = src.charAt(i); //Read next char
        if (c == '<') {
            //Tag found
            end = src.slice(i).indexOf(">");
            if (end == -1) { //Check for incomplete tag
                return str;
            }
            end += i + 1;
            tag = src.slice(i, end); //Read tag contents
            str += tag; //Append the tag to final content
            if (tag.charAt(1) == "/") {
                //Closing tag
                tagTree = tagTree.slice(0, -1);
            } else {
                //New tag
                tagTree.push(tagStrip(tag));
            }
            i = end; //Move the position to end of the tag

        } else {
            //Append content character and move the position
            str += c;
            i++;
            cnt++;
        }
    }
    //Go through all open tags and close them
    if (str.endsWith(',')) str = str.substring(0, str.length - 1)
    if (suffix) str += suffix;
    if (tagTree.length > 0) {
        for (i = tagTree.length - 1; i >= 0; i--) {
            const tagName = tagTree[i];
            if (!['br', 'hr', 'area', 'base', 'col', 'embed', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'].includes(tagName))
                str += "</" + tagTree[i] + ">";
        }
    }
    //Return final cutted content and put suffix after it
    // if(suffix === false) return str;
    // return str + ((typeof suffix == "undefined" || suffix === true) ? "..." : suffix);
    return str;
}

// function smart_substr(str: string, count: number ) : JQuery {
//     const div = $(`<div>${str}</div>`);
//     walk(div[0]);
//     function track( el: Text ) {
//         if( count > 0 ) {
//             var len = el.data.length;
//             count -= len;
//             if( count <= 0 ) {
//                 el.data = el.substringData( 0, el.data.length + count );
//             }
//         } else {
//             el.data = '';
//         }
//     }
//     function walk(el: HTMLElement|ChildNode ) {
//         let node: ChildNode|null|undefined = el.firstChild;
//         while(node) {
//             if( node!.nodeType === 3 ) {
//                 track(node as Text);
//             } else if( node!.nodeType === 1 && node!.childNodes && node!.childNodes[0] ) {
//                 walk(node);
//             }
//             node = node.nextSibling
//             //@ts-ignore
//         }
//     }
//     $('<div>... </div>').appendTo(div);
//     return div;
// }


function ReviewRating({v, k, className}: { v: number, k: string, className?: string }) {
    let className1 = 'rating-category-item';
    if (v == 5) {
    } else if (v > 5) className1 += ' good'
    else className1 += ' bad';
    if (className) className1 += ' ' + className;
    return (
        <li className={className1}>
            <div className="rating-category-key">{k}</div>
            <div className="rating-category-value">
                <div className="rating-category-num">
                    <span className="rating-category-num-item">{v}</span> <span>/ 10</span>
                </div>
                <div className="rating-category-text">{ratingList[+v]}</div>
            </div>
        </li>
    )
}

function ReviewText({html, id}: { html: string; id: number }) {
    if (html.length > 1000) {
        const text = html_substr(html, 1000, '... ');
        const nodes = createElementFromHTML(text);
        return (
            <>
                <div className="comment-text fr-basic">{nodes}</div>
                <a href={`/reviews/${id}`} className="read-more-link" title="Ссылка откроется в новом окне"
                   target="_blank">
                    <i className="fa fa-external-link"/> Читать полный текст рецензии
                </a>
            </>
        )
    } else return (
        <>
            <div className="comment-text fr-basic">{createElementFromHTML(html)}</div>
            <a className="discussion-button" title="Ссылка откроется в новом окне" target="_blank"
               href={`/reviews/${id}`}>
                <i className="far fa-comments"/> Обсудить рецензию
            </a>
        </>
    )
}